module.exports = __webpack_public_path__ + "img/00050.3f10abf6.webp";